import * as C from '../constants';
import { Lng } from '../enums';

const INITIAL_STATE = Object.freeze({
  lng: Lng.LV,
  errorData: [],
  homeData: null,
  periodData: {},
  allAlbumData: null,
  searchData: null,
  mapData: null,
  addData: null,
  successData: null,
});

// eslint-disable-next-line
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case C.SET_LANGUAGE: {
      return {
        ...state,
        lng: action.payload,
      };
    }
    case C.STORE_ERROR: {
      const existingErrors = state.errorData;
      const latestError = [action.payload];
      const errorData = [...existingErrors, ...latestError];

      return {
        ...state,
        errorData,
      };
    }
    case C.CLOSE_ERROR: {
      const existingErrors = state.errorData;
      // eslint-disable-next-line
      const removedError = existingErrors.shift();
      const errorData = [...existingErrors];

      return {
        ...state,
        errorData,
      };
    }
    case C.HOME_DATA: {
      return {
        ...state,
        homeData: action.payload,
      };
    }
    case C.PERIOD_DATA: {
      return {
        ...state,
        periodData: { ...state.periodData, ...action.payload.period },
      };
    }
    case C.ALL_ALBUM_DATA: {
      return {
        ...state,
        allAlbumData: action.payload,
      };
    }
    case C.SEARCH_DATA: {
      return {
        ...state,
        searchData: action.payload,
      };
    }
    case C.MAP_DATA: {
      return {
        ...state,
        mapData: action.payload,
      };
    }
    case C.ADD_DATA: {
      return {
        ...state,
        addData: action.payload,
      };
    }
    case C.SHOW_SUCCESS: {
      return {
        ...state,
        successData: action.payload,
      };
    }
    default:
      return state;
  }
};
